export const CustomsFormStatus = Object.freeze({
  CustomsNotRequired: 'CustomsNotRequired',
  CustomsNotDeclared: 'CustomsNotDeclared',
  LabelNotCreated: 'LabelNotCreated',
  CustomsOnLabel: 'CustomsOnLabel',
  HasCustomsFile: 'HasCustomsFile',
  HasCustomsButForbidden: 'HasCustomsButForbidden',
});
